<div class="w-full p-2 pr-4 text-center orange-background">
  <p class="m-0 text-sm" [ngSwitch]="bannerType">
    <ng-container *ngSwitchCase="'offboarded'">{{ 'HEAD_BANNER.OFFBOARDED' | translate }}</ng-container>
    <ng-container *ngSwitchCase="'offboardedCoach'">{{ 'HEAD_BANNER.OFFBOARDED_COACH' | translate }}</ng-container>
    <ng-container *ngSwitchCase="'notresponsive'">{{ 'HEAD_BANNER.NOT_RESPONSIVE' | translate }}</ng-container>
    <ng-container *ngSwitchCase="'tutorial'"
      >{{ 'HEAD_BANNER.TUTORIAL' | translate }} <a [routerLink]="TUTORIAL" class="underline">{{ 'HEAD_BANNER.HERE' | translate }}</a>.
    </ng-container>
    <ng-container *ngSwitchCase="'tutorial-coach'">
      {{ 'HEAD_BANNER.TUTORIAL_COACH' | translate }} <a [routerLink]="TUTORIAL" class="underline">{{ 'HEAD_BANNER.HERE' | translate }}</a>.
    </ng-container>
    <ng-container *ngSwitchCase="'czMaterialsEn'">{{ 'HEAD_BANNER.MATERIALS_IN_EN' | translate }}</ng-container>
    <a *ngSwitchCase="'networkingRound'" [routerLink]="NETWORKING" class="block text-inherit no-underline hover:opacity-90">
      {{ 'HEAD_BANNER.NETWORKING_ROUND' | translate }}
    </a>
  </p>
</div>